import React from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import LoginWrapper from "./LoginWrapper";
import "./LoginPrompt.css";

class LoginPrompt extends React.Component {
  render() {
    return (
      <CSSTransitionGroup
        transitionName="loginprompt"
        transitionAppear={true}
        transitionAppearTimeout={50}
        transitionEnter={false}
        transitionLeave={false}
      >
        <div
          className={`login-prompt ${this.props.loginPromptClosing ? "closing" : "open"}`}
          key="1"
        >
          <LoginWrapper
            loginClosing={this.props.loginPromptClosing}
            handleCloseLoginPrompt={this.props.handleCloseLoginPrompt}
          />
        </div>
      </CSSTransitionGroup>
    );
  }
}

export default LoginPrompt;
